import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import logoCircle from "../../Assets/logo_circle.png";
import logoWoOutline from "../../Assets/logo_wo_outline.png";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.4em", paddingBottom: "20px", textAlign: 'left', color: "#979797" }}>
              Create memorable moments with <span className="purple"> Song of Songs </span>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={logoCircle} alt="about" className="img-fluid" />
          </Col>
        </Row>
        
        <img src={logoWoOutline} alt="about" className="img-fluid" style={{height: 60}} />
      </Container>
    </Container>
  );
}

export default About;
